var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.41661 0.916882V7.43271L1.56994 4.58605C1.34244 4.35855 0.969109 4.35855 0.741609 4.58605C0.514109 4.81355 0.514109 5.18105 0.741609 5.40855L4.58578 9.25271C4.81328 9.48021 5.18078 9.48021 5.40828 9.25271L9.25244 5.40855C9.47994 5.18105 9.47994 4.81355 9.25244 4.58605C9.02494 4.35855 8.65744 4.35855 8.42994 4.58605L5.58328 7.43271L5.58328 0.916882C5.58328 0.596047 5.32078 0.333548 4.99994 0.333548C4.67911 0.333548 4.41661 0.596047 4.41661 0.916882Z",
    fill: "#CF0505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.6e30adfe16f1f827f52ca11448d1b40a.svg";
export { ForwardRef as ReactComponent };